import React from 'react';
import ModernCTA from '../CTA/ModernCTA';

// Wrapper component for backward compatibility
const CtaSection = (props) => {
    return <ModernCTA {...props} />;
};

export default CtaSection;
